import { useSalesContractProvider } from '../../Sales.Contract.Hooks';
import ContractInfoDetails from './Contract.Info.Details';

export default function ContractInfoGeneralInfo() {
  const { selected } = useSalesContractProvider();

  return <ContractInfoDetails contract={selected} />;
}
